import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminOrdersTranslation } from "../../translations";
import { formatCurrency } from "../utils/orderDetailsUtils";

const ShippingInfoSection = ({ order }) => {
    const { language } = useLanguage();
    const { t } = useAdminOrdersTranslation(language);

    return (
        <div className="shipping-info-section">
            <h2>{t('shippingInformation')}</h2>
            {order.shippingInfo && (
                <>
                    <div className="info-row">
                        <span className="info-label">{t('shippingAddress')}:</span>
                        <span className="info-value">{order.shippingInfo.address}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">City:</span>
                        <span className="info-value">{order.shippingInfo.city}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">State/Province:</span>
                        <span className="info-value">{order.shippingInfo.state}</span>
                    </div>

                    <div className="info-row">
                        <span className="info-label">Country:</span>
                        <span className="info-value">{order.shippingInfo.country}</span>
                    </div>
                </>
            )}
            {order.shipping && (
                <>
                    <div className="info-row">
                        <span className="info-label">{t('shippingMethod')}:</span>
                        <span className="info-value">{order.shipping.method}</span>
                    </div>
                    <div className="info-row">
                        <span className="info-label">{t('shippingCost')}:</span>
                        <span className="info-value">
                            {order.currency} {formatCurrency(order.shipping?.cost)}
                        </span>
                    </div>
                </>
            )}
        </div>
    );
};

export default ShippingInfoSection;